import React from 'react';
import { situations } from '../data/content';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './CtaButton';
export function ForYou() {
  return <section className="bg-white py-16 sm:py-24" data-id="element-161" data-mp="3gqny77sq9mr5">
      <div className="mx-auto max-w-6xl px-4" data-id="element-162" data-mp="3gs8q0pnnqrlb">
        <SectionHeading eyebrow="Is This for You?" title="Do Any of These Situations Sound Familiar?" intro="If you recognize even one of these situations, I created Third Molar Assessment Blueprint™ with you in mind." data-id="element-163" data-mp="3bzz1ne26xzl5" />

        <ol className="mt-12 grid gap-x-10 gap-y-8 sm:grid-cols-2 lg:grid-cols-3" data-id="element-164" data-mp="3lpio0tp44bkr">
          {situations.map((s, i) => <li key={s.title} className="border-t-2 border-navy pt-5" data-id="element-165" data-mp="3ht72x582xwb" data-mpi={i}>
              <span className="font-display text-4xl font-bold text-accent" data-id="element-166" data-mp="3vogc5vimm338">{i + 1}</span>
              <h3 className="mt-2 text-lg font-bold leading-snug text-ink" data-id="element-167" data-mp="25caemf50btgx">{s.title}</h3>
              <p className="mt-2 text-[15px] leading-relaxed text-muted" data-id="element-168" data-mp="21ayrqhdipmcf">{s.text}</p>
            </li>)}
        </ol>

        <div className="mx-auto mt-12 max-w-2xl space-y-3 text-center text-[17px] leading-relaxed text-ink/85" data-id="element-169" data-mp="349s771mgn3zl">
          <p data-id="element-170" data-mp="394pea306j39u">And that’s exactly why I built Third Molar Assessment Blueprint™.</p>
          <p data-id="element-171" data-mp="3e4tvjv8ww214">The problem isn’t always a lack of knowledge.</p>
          <p className="font-display text-2xl font-bold leading-snug text-ink" data-id="element-172" data-mp="3ix4twto07frk">
            Sometimes, it’s the lack of a clear structure for organizing the knowledge you already have.
          </p>
        </div>

        <div className="mt-10" data-id="element-173" data-mp="3rw8g46igwbaa">
          <CtaButton label="I Want a Structured Third Molar Framework" data-id="element-174" data-mp="3rzmi3dn7yih7" />
        </div>
      </div>
    </section>;
}